import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Form from "../../../Utils/Form/Formik"; // Assuming this is your custom Form component
import { updateuserdata } from "../../../Services/Admin/Addmin";
import { getEmployee_permissiondata } from "../../../Services/Employee/Employee";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const Updateuser = () => {
  const TokenData = getUserFromToken();
  const navigate = useNavigate();
  const location = useLocation();
  const user_id = TokenData?.user_id;
  const [getaccess, setGetaccess] = useState({});
  const { rowData } = location.state;

  useEffect(() => {
    getpermission()
  }, [])


  const getpermission = async () => {
    try {
      const data = { id: user_id };
      const response = await getEmployee_permissiondata(data);
      if (response.status) {
        setGetaccess(response.data[0]);
      }
    } catch (error) { }
  };


  const formik = useFormik({
    initialValues: {
      fullName: "",
      username: "",
      email: "",
      phone: "",
      employee_id: "",

      limit: "",
      selectedOption: "",
      inputValue: "",
      price_zero_status: false,
      hide_sell_button: false,
      option_status: false,
      trade_block_time: "",
    },
    validate: (values) => {
      let errors = {};

      // Full Name validation
      if (!values.fullName) {
        errors.fullName = "Please Enter Full Name";
      }

      // Username validation
      if (!values.username) {
        errors.username = "Please Enter Username";
      }

      // Email validation
      if (!values.email) {
        errors.email = "Please Enter Email Address";
      } else if (!/^\S+@\S+\.\S+$/.test(values.email)) {
        errors.email = "Please enter a valid email address.";
      }

      // Phone validation
      if (!values.phone) {
        errors.phone = "Please Enter Phone Number";
      }

      // Limit validation
      if (getaccess?.limit_edit == 1) {
        if (!values.limit) {
          errors.limit = "Please enter a value for Limit";
        } else if (
          isNaN(values.limit) ||
          values.limit < 0 ||
          values.limit > 100
        ) {
          errors.limit = "Limit must be a number between 0 and 100.";
        }
      }


      // Selected option validation
      if (!values.selectedOption) {
        errors.selectedOption = "Please select an option";
      }

      // Input value validation
      if (!values.inputValue) {
        errors.inputValue = "Please enter a value for the selected option";
      }

      return errors;
    },

    onSubmit: async (values, { setSubmitting }) => {


      if (values.limit < 0 || values.limit > 100) {
        Swal.fire({
          title: "Invalid Input",
          text: "Limit must be a number between 0 and 100.",
          icon: "warning",
          timer: 2000,
          timerProgressBar: true,
        });
        setSubmitting(false);
        return;
      }

      const data = {
        id: rowData && rowData._id,
        limit: values.limit,
        [values.selectedOption]: values.inputValue,
        option_selling_permission: values.option_selling_permission,
        price_zero_status: values.price_zero_status,
        option_status: values.option_status ? 1 : 0,
        hide_sell_button: values.hide_sell_button,
        trade_block_time: values.trade_block_time,
      };

      try {
        const response = await updateuserdata(data);

        if (response && response.status) {
          Swal.fire({
            title: "User Updated!",
            text: "User updated successfully",
            icon: "success",
            timer: 2000,
            timerProgressBar: true,
          });
          setTimeout(() => navigate("/admin/users"), 2000);
        } else {
          Swal.fire({
            title: "Update Failed",
            text: response?.message || "Unknown error occurred.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to update user. Please try again later.",
          icon: "error",
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (rowData) {
      const determineSelectedOption = () => {
        if (rowData.pertrade && rowData.pertrade !== 0) {
          return "pertrade";
        } else if (rowData.perlot && rowData.perlot !== 0) {
          return "perlot";
        }
        return "pertrade";
      };

      formik.setValues({
        fullName: rowData.FullName || "",
        username: rowData.UserName || "",
        email: rowData.Email || "",
        phone: rowData.PhoneNo || "",
        selectedOption: rowData.selectedOption || determineSelectedOption(),
        inputValue: rowData.pertrade || rowData.perlot || "",
        limit: rowData.limit || "",
        option_selling_permission: rowData.option_selling_permission || false,
        price_zero_status: rowData.price_zero_status || false,
        hide_sell_button: rowData.hide_sell_button || false,
        option_status: rowData.option_status === 1 ? true : false,
        trade_block_time: rowData.trade_block_time || "",
      });
    }
  }, [rowData]);

  const getInputValueLabel = (selectedOption) => {
    if (selectedOption === "pertrade") return "Enter Value for Per Trade";
    if (selectedOption === "perlot") return "Enter Value for Per Lot";
    return "Enter Value";
  };

  // Form fields configuration
  const fields = [
    {
      name: "fullName",
      label: "Full Name",
      type: "text",
      label_size: 6,
      col_size: 6,
      disable: true,
    },
    {
      name: "username",
      label: "Username",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: true,
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: true,
    },
    {
      name: "phone",
      label: "Phone Number",
      type: "text3",
      label_size: 12,
      col_size: 6,
      disable: true,
    },


    getaccess?.limit_edit == 1 && {
      name: "limit",
      label: "INTRADAY Margin",
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: false,
      min: 0,
      max: 100,
      step: 1,
    },
    {
      name: "selectedOption",
      label: "Select One Option",
      type: "select",
      options: [
        { value: "pertrade", label: "Per Trade" },
        { value: "perlot", label: "Per Lot" },
      ],
      label_size: 12,
      col_size: 6,
      disable: false,
    },
    {
      name: "inputValue",
      label: getInputValueLabel(formik.values.selectedOption),
      type: "text",
      label_size: 12,
      col_size: 6,
      disable: false,
      showWhen: (values) => !!values.selectedOption,
    },
    {
      name: "",
      label: "",
      type: "",
      col_size: 6,
      label_size: 12,
      disable: false,
    },
    {
      name: "option_selling_permission",
      label: "Forex Option Selling Permission",
      type: "toggle",
      col_size: 6,
      label_size: 12,
      disable: false,
    },
    {
      name: "hide_sell_button",
      label: "INR Option Selling Permission",
      type: "toggle",
      col_size: 6,
      label_size: 12,
    },

    {
      name: "option_status",
      label: "Forex Option Chain Price Zero Permission",
      type: "toggle",
      col_size: 6,
      label_size: 12,
    },
    {
      name: "price_zero_status",
      label: "INR Option Chain Price Zero Permission",
      type: "toggle",
      col_size: 6,
      label_size: 12,
    },

  ];

  return (
    <Form
      fields={fields}
      page_title="Update User"
      btn_name="Update User"
      btn_name1="Cancel"
      formik={formik}
      btn_name1_route={"/employee/users"}
      additional_field={

        <div className="col-lg-6 mt-4">
          <div className="mb-3 ">
            <label className="fw-bold">Trade Block Duration</label>
            <input
              type="text"
              className="form-control"
              placeholder="mm:ss"
              value={formik.values.trade_block_time || ""}
              onChange={(e) => {
                let value = e.target.value;

                // Auto-format only mm:ss allowed
                if (/^[0-9]{0,2}(:[0-9]{0,2})?$/.test(value)) {
                  formik.setFieldValue("trade_block_time", value);
                }
              }}
            />
            <small className="text-muted">Format: mm:ss (Example: 05:30)</small>
          </div>
        </div>
      }
    />
  );
};

export default Updateuser;
